/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

/** React library */
import { Component } from "react";

/** React bootstrap */
import { Button, Modal } from 'react-bootstrap';

/** React redux */
import store from 'features/store';
import { connect } from "react-redux";

/** Style */
import './ErrorModal.scss';

class ErrorModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: false
        }
    }

    handleClose = (event) => {
        store.dispatch({ type: "ERROR_MODAL", payload: { show: false, message: null } });
    }

    render() {
        return (
            <Modal id="error-modal-main" animation={false}
                show={this.props.showErrorModal.show}
                className=" animate__animated animate__fadeInUp"
                aria-labelledby="contained-modal-error-modal"
                onHide={this.handleClose}
                centered>
                <Modal.Body>
                    <div>
                        <div className="api-error my-2">{this.props.showErrorModal.message}</div>
                        {
                            this.props.showErrorModal.link ?
                                <div dangerouslySetInnerHTML={{ __html: this.props.showErrorModal.link }}></div> : null
                        }
                        <div className="d-flex align-items-center justify-content-center">
                            <Button variant="outline-dark btn-white mx-2" onClick={this.handleClose}>
                                Close
                            </Button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

export default connect(state => state)(ErrorModal);